import { getCookie } from "app/assets/javascripts/tracking/base-tracker"
import { getSlideshowViewEventOptions } from "./log-slideshow-events"

export default function logEvent(name, options, callbackSuccessFn, callbackErrorFn) {
  if (typeof window.amplitude === "undefined") return

  const globalOptions = {
    browserId: getCookie("browser_id"),
  }
  const updatedOptions = Object.assign({}, options, globalOptions)
  window.amplitude.getInstance().logEvent(name, updatedOptions, callbackSuccessFn, callbackErrorFn)
}

export const navigateAfterTracking = (eventName, event, uri) => {
  const redirectUri = uri ?? event?.currentTarget.href
  if (event) {
    event.preventDefault()
  }
  logEvent(eventName, getSlideshowViewEventOptions(), () => (window.location.href = redirectUri))
}